import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'
import http from 'utils/http'
import { endpoints } from 'global/endpoints'
import { toast } from 'react-toastify'
import { routePaths } from 'global/routePaths'

const createUser = (postData) => {
  const updatedEndpoints = endpoints.user.base
  return http('multipart').post(updatedEndpoints, postData)
}

export function useCreateUser() {
  const history = useHistory()

  return useMutation(createUser, {
    onSuccess: () => {
      toast.success('User has been added successfully!')
      history.push(routePaths.home.user.base)
    },
    onError: (error) => {
      const message = error.response.data.message
      toast.error(message)
    },
  })
}
